var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 218,
    viewBox: "0 0 153 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 76.5 109)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5 0C79.7677 0 82.897 1.3277 85.1711 3.68L149.592 70.2911C154.237 75.0929 154.119 82.7609 149.329 87.4164C144.54 92.0735 136.893 91.9556 132.25 87.1532L88.5789 41.9981V205.889C88.5789 212.577 83.1708 218 76.5 218C69.8292 218 64.4211 212.577 64.4211 205.889V41.9981L20.7502 87.1532C16.1071 91.9556 8.46029 92.0735 3.6706 87.4164C-1.11909 82.7609 -1.23665 75.0929 3.40809 70.2911L67.8289 3.68C70.103 1.3277 73.2323 0 76.5 0Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f1b8c80217886071ef9a2df839483c4b.svg";
export { ForwardRef as ReactComponent };